import { render, staticRenderFns } from "./EditorInPageButtons.vue?vue&type=template&id=edc43294&"
import script from "./EditorInPageButtons.vue?vue&type=script&lang=js&"
export * from "./EditorInPageButtons.vue?vue&type=script&lang=js&"
import style0 from "./EditorInPageButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditorInPageButtons.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/EditorInPageButtons.vue
// module id = 2291
// module chunks = 1